import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from "typeorm";
import { SectionQuestionMappingEntity } from "./section-question-mapping.entity";
import { QuestionPaperModal } from "../../model-paper/entities/question-paper-modal";

@Entity("question_papers")
export class QuestionPapers {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("text", { name: "qnos" })
  qnos: string;

  @Column("int", { name: "setno" })
  setNo: number;

  @Column("int", { name: "status" })
  status: number;

  @Column("varchar", { name: "timestamp", length: 20 })
  timestamp: string;

  @Column("varchar", { name: "otp", length: 20, nullable: true })
  otp: string;

  @Column("varchar", { name: "paper_bundler_id", length: 20, nullable: false })
  paperBundlerId: string;

  @Column("text", { name: "qnos_order" })
  qnosOrder: string;

  @Column("int", { name: "user_id"})
  userId: number;

  @ManyToOne(() => QuestionPaperModal, (qnpModel) => qnpModel.sectionsWiseModel)
  @JoinColumn({ name: 'qpcode' })
  qpCode: QuestionPaperModal

  @OneToMany(() => SectionQuestionMappingEntity, (sections) => sections.questionPaper, { cascade: true })
  sectionsQuestionMapping: SectionQuestionMappingEntity[];

}
